<template>
  <div>
    <b-form>
      <b-form-group label="Selecione o(s) Servidor(es):" required>
        <multiselect
          v-model="destinatarios"
          :close-on-select="true"
          :multiple="true"
          :options="servidores"
          :searchable="true"
          :show-labels="false"
          placeholder="Selecione..."
        ></multiselect>
      </b-form-group>
      <b-form-group label="Signatários:" required>
        <multiselect
          v-model="signatarios"
          :close-on-select="true"
          :multiple="true"
          :options="usuarios"
          :searchable="true"
          :show-labels="false"
          :taggable="true"
          placeholder="Selecione..."
        ></multiselect>
      </b-form-group>
      <b-form-group id="input-group-1" label="Processo:" label-for="referente">
        <b-form-input
          id="referente"
          disabled
          type="text"
          v-bind:value="processo.protocolo"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Data:" label-for="referente">
        <b-form-input
          id="referente"
          disabled
          type="text"
          v-bind:value="date"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1">
        <vue-editor
          v-model="mensagem"
          :editorToolbar="editorToolbar"
        ></vue-editor>
      </b-form-group>

      <b-button variant="primary" @click="redigirDocumento()" class="px-5 py-2"
        >Salvar
      </b-button>
    </b-form>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment'

import 'moment/locale/pt'  // without this line it didn't work
moment.locale('pt')

export default {
  components: {
    Multiselect,
  },
  name: 'Despacho',
  data() {
    return {
      date: 'Macapá/AP,',
      editorToolbar: [
        ['bold', 'italic', 'underline'],
        [{ color: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: 'center' }, { align: 'justify' }, { align: 'right' }],
      ],
      mensagem: '',
      destinatarios: [],
      servidores: [],
      usuarios: [],
      usuariosIds: [],
      signatarios: [],
      processos: [],
    };
  },
  methods: {
    getServidoresSDC() {
      this.$http
        .get('servidores-sdc')
        .then(res => {
          res.data.forEach(servidor => {
            this.servidores.push(`${servidor.name} - ${servidor.setor.nome}`);
          });
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    redigirDocumento() {

      if(!this.mensagem || this.destinatarios.length == 0 || this.signatarios.length == 0){
        this.$swal({
          title: 'Preencha todos os campos!',
          icon: 'warning',
        });

        return null
      }

      let indexes = this.usuarios.map((value, index) => {
        if (this.signatarios.includes(value)) {
          return index;
        }
      });
      let signatariosIds = this.usuariosIds.filter((value, index) => {
        if (indexes.includes(index)) {
          return value;
        }
      });
      let data = {
        mensagem: this.mensagem,
        tipo_documentos_id: this.tipo_documentos_id,
        processo: this.processo,
        destinatarios: this.destinatarios,
        signatarios: signatariosIds,
        numero_processo: this.processo.protocolo,
        processo_id: this.processo.id,
      };

      this.$http.post('documentos-redigidos', data).catch(error => {
        console.log(error.response);
      });

      this.$swal({ title: 'Documento redigido com sucesso!', icon: 'success' });
      this.$emit('refreshProcesso');
      this.limpar();
    },
    limpar() {
      this.mensagem = '';
      this.destinatarios = [];
      this.signatarios = [];
    },
    getUsuarios() {
      this.$http
        .get('servidores-sdc')
        .then(res => {
          res.data.forEach(user => {
            this.usuarios.push(user.name);
            this.usuariosIds.push(user.id);
          });
        })
        .catch(error => {
          console.log(error.response);
        });
    },
  },
  created() {
    this.getServidoresSDC();
    this.getUsuarios();

    this.date = `${this.date} ${moment().format('LL')}`
  },
  props: {
    processo: {
      type: Object,
    },
    tipo_documentos_id: {
      type: Number,
    },
  },
};
</script>
